import { Person as PersonIcon } from '@mui/icons-material'
import { Grid, Typography } from '@mui/material'
import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { AppRoutes } from '../../models'
import { CustomerEntry } from '../../sdk'
import { formatName } from '../../utils/formatCustomerName/formatCustomerName'
import { ClickableDeletableCard } from '../SharedUI'

interface Props {
  customers: CustomerEntry[]
}

export const CustomersByVehicle: FC<Props> = ({ customers }) => {
  const navigate = useNavigate()

  return (
    <Grid container spacing={2} direction="row">
      {customers.map((customer) => {
        return (
          <Grid item key={customer.id!}>
            <ClickableDeletableCard
              data-testid="vehicleCard"
              label={
                <Typography
                  sx={{
                    width: '150px',
                    boxSizing: 'border-box',
                    wordBreak: 'break-all',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                  {formatName(customer.information)}
                </Typography>
              }
              icon={<PersonIcon />}
              onClick={() => navigate(AppRoutes.CUSTOMERS + '/' + customer.id)}
            />
          </Grid>
        )
      })}
    </Grid>
  )
}
